import React, {Component} from 'react';
import $ from 'jquery';

const createCookie = require('../../cookie.js').createCookie;
const readCookie = require('../../cookie.js').readCookie;
const eraseCookie = require('../../cookie.js').eraseCookie;

const email_validator = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;

export default class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: null,
      forgotPassword: false,
      forgotPasswordEmail: null,
      submittedForgotPassword: false,
      forgotPasswordEmailValid: true,
    };
    this.checkUser = this.checkUser.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.signupUser = this.signupUser.bind(this);
    this.lockPortal = this.lockPortal.bind(this);
    this.unlockPortal = this.unlockPortal.bind(this);
    // this.tickTimer = this.tickTimer.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }

  componentWillMount() {
    this.checkUser();
    // this.tickTimer();
  }

  checkUser() {
    if(readCookie('userData') !== null) {
      if(readCookie('leBackOfficeVersion') !== null) {
        if(readCookie('leBackOfficeVersion') === process.env.REACT_APP_VERSION) {
          this.setState({
            userData: JSON.parse(readCookie('userData'))
          });
        } else {
          eraseCookie('userData');
          eraseCookie('access_token');
          eraseCookie('leBackOfficeVersion');
          this.setState({ userData: null });
          window.location.pathname = '';
        }
      } else {
        eraseCookie('userData');
        eraseCookie('ngo');
        eraseCookie('access_token');
        eraseCookie('leBackOfficeVersion');
        this.setState({ userData: null });
        window.location.pathname = '';
      }
      if(readCookie('portalLocked') !== null) {
        this.setState({
          portalLocked: readCookie('portalLocked')
        })
      }
    }
  }

  signupUser(e) {
    // e.preventDefault();
    // let ngoName = $('#signup-form #ngo-name').val();
    // let orgType = $('#signup-form #org-type').val();
    // let email = $('#signup-form #new-user-email').val();
    // let mobile = $('#signup-form #new-user-mobile').val();

    // if(ngoName !== '' && orgType !== '' && email !== '' && email.match(email_validator) !== null && mobile !== '') {
    //   this.setState({ knowMoreError: false });
    //   $('#signup-spinner').removeClass('hidden');
    //   $('#signup-span').addClass('hidden');
    //   let data = {
    //     'ngoName': ngoName,
    //     'orgType': orgType,
    //     'email': email,
    //     'mobile': mobile
    //   }
    //   fetch(process.env.REACT_APP_API_URL + '/new_user_contact', {
    //     method: "POST",
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(data)
    //   }).then(function(response) {
    //     return response.json();
    //   }).then(function(data) {
    //     if(data['success']) {
    //       swal({
    //         title: 'Hi!',
    //         html: '<h4>We appreciate your interest</h4><br />We will get back to you within the next <b>24hrs</b>',
    //         type: 'success'
    //       });
    //       $('#signup-spinner').addClass('hidden');
    //       $('#signup-span').removeClass('hidden');
    //     }
    //   });
    // } else {
    //   this.setState({ knowMoreError: true });
    // }
  }

  updateUser(first_name, last_name, profile_picture) {
    // var userData = this.state.userData;
    // if(first_name !== '') userData['first_name'] = first_name;
    // if(last_name !== '') userData['last_name'] = last_name;
    // if(profile_picture !== '') userData['profile_picture'] = profile_picture;
    // this.setState({ userData: userData });
    // eraseCookie('userData');
    // createCookie('userData', JSON.stringify(userData), 7);
  }

  lockPortal() {
    this.setState({ portalLocked: true });
    createCookie('portalLocked', true, 7);
  }

  unlockPortal() {
    // fetch(process.env.REACT_APP_API_URL + '/check_user')
    this.setState({ portalLocked: false });
    createCookie('portalLocked', false, 7);
  }

  loginUser(e) {
    e.preventDefault();
    let email = $('#login-form #email').val();
    let password = $('#login-form #password').val();

    if(email != '' && email.match(email_validator) !== null && password != '') {
      $('#login-spinner').removeClass('hidden');
      $('#login-span').addClass('hidden');
      let data = {
        'email': email,
        'password': password
      };
      fetch(process.env.REACT_APP_API_URL + '/login', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        console.log(data)
        if (data['status'] === 'success') {
          createCookie('access_token', JSON.stringify(data.token.access_token), 7);
          createCookie('userData', JSON.stringify(data.data), 7);
          createCookie('leBackOfficeVersion', process.env.REACT_APP_VERSION, 7);
          window.location.reload(true);
        } else if (data['status'] === 'error') {
          $('#login-spinner').addClass('hidden');
          $('#login-span').removeClass('hidden');
          $('.wrong-details').css('display','block');
        }
      });
    } else {
      if(email === '' || email.match(email_validator) === null || password === '') {
        $('#login-spinner').addClass('hidden');
        $('#login-span').removeClass('hidden');
        $('.wrong-details').css('display','block');
      }
    }
  }

  logoutUser() {
    // fetch(process.env.REACT_APP_API_URL + '/logout', {
    //   method: "POST",
    //   headers: {
    //     'Authorization': 'Bearer '+JSON.parse(readCookie('access_token')).access_token
    //   }
    // }).then(function(response) {
    //   return response.json();
    // }).then(function(data) {
    //   eraseCookie('userData');
    //   eraseCookie('access_token');
    //   eraseCookie('leBackOfficeVersion');
    //   this.setState({
    //     userData: null,
    //     ngo: null
    //   });
    //   window.location.pathname = '';
    // }.bind(this)).catch(function(error) {
    //   console.log('There has been a problem with your fetch operation: ' + error.message);
    // });
  }

  updateNgoData() {
  //   fetch(process.env.REACT_APP_API_URL + '/ngo/' + this.state.ngo.ngo_id, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer '+JSON.parse(readCookie('access_token')).access_token
  //     }
  //   }).then(function(response) {
  //     return response.json();
  //   }).then(function(data) {
  //     var ngo = data['ngo'];
  //     this.setState({ ngo });
  //     createCookie('ngo', JSON.stringify(ngo), 7);
  //   }.bind(this));
  // }

  // tickTimer() {
  //   var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  //   var newTime = new Date().toLocaleTimeString();
  //   var newDate = new Date().toLocaleDateString('en-US', options);
  //   this.setState({
  //     time: newTime,
  //     date: newDate
  //   });
  }

  setLoginForm() {
    $('.form').find('input, textarea').on('keyup blur focus', function(e) {
      var $this = $(this), label = $this.prev('label');
      if($(this).hasClass('wrong')) $(this).removeClass('wrong');
      if (e.type === 'keyup') {
        if ($this.val() === '') label.removeClass('highlight');
        else label.addClass('active highlight');
      } else if (e.type === 'blur') {
        if ($this.val() === '') label.removeClass('active highlight');
        else label.removeClass('highlight');
      } else if (e.type === 'focus') {
        label.addClass('active highlight');
      }
    });

    $(document).ready(function() {
      if($('input#email').val() !== '') {
        if(!$('input#email').siblings('label').hasClass('active')) $('input#email').siblings('label').addClass('active');
      }
      if($('input#password').val() !== '') {
        if(!$('input#password').siblings('label').hasClass('active')) $('input#password').siblings('label').addClass('active');
      }
    })

    $('.tab a').on('click', function(e) {
      e.preventDefault();
      $(this).parent().addClass('active');
      $(this).parent().siblings().removeClass('active');
      let target = $(this).attr('href');
      $('.tab-content > div').not(target).hide();
      $(target).fadeIn(600);
    });
  }

  componentDidMount() {
    this.setLoginForm();
  }

  componentDidUpdate() {
    this.setLoginForm();
  }

  change() {
    if($('#login-form #email').siblings('label').hasClass('wrong')) {
      $('#login-form #email').siblings('label').removeClass('wrong');
      $('.wrong-email').hide();
    }
    if($('#login-form #password').siblings('label').hasClass('wrong')) {
      $('#login-form #password').siblings('label').removeClass('wrong');
      $('.wrong-password').hide();
    }
  }

  onChangeSwitch() {
    this.setState({ donorDonationSwitchChecked: !this.state.donorDonationSwitchChecked })
  }

  forgotPassword() {
    this.setState({ forgotPassword: !this.state.forgotPassword });
  }

  changeForgotPasswordEmail(e) {
    this.setState({ forgotPasswordEmail: e.target.value, forgotPasswordEmailValid: email_validator.test(e.target.value) });
  }

  forgotPasswordSubmit() {
    if(this.state.forgotPasswordEmail !== '' && email_validator.test(this.state.forgotPasswordEmail)) {
      this.setState({ submittedForgotPassword: true });
      fetch(process.env.REACT_APP_API_URL + '/forgot_password', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'email': this.state.forgotPasswordEmail })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        setTimeout(function() {
          this.setState({
            forgotPassword: false,
            forgotPasswordEmail: null,
            submittedForgotPassword: false
          });
        }.bind(this), 1000);
      }.bind(this));
    } else {
      this.setState({ forgotPasswordEmailValid: false });
    }
  }

  render() {
    if(this.state.userData === null) {
      return (
        <div id="login-container">
          <div className="sahaj-front">
            <div id="sahaj-heading">LE - Back Office</div>
            <div id="sahaj-quote">LetsEndorse is an online ecosystem of social innovators, NGOs and communities. Let's power sustainable social projects on our collaborative crowdfunding platform.</div>
            <div id="points">
              <div className="point">
                <div className="icon">
                  <span>
                    <i className="fa fa-2x fa-sitemap" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="heading">Organisation</div>
                <div className="desc"></div>
              </div>
              <div className="point">
                <div className="icon">
                  <i className="fa fa-2x fa-chevron-right" aria-hidden="true"></i>
                  <span>
                    <i className="fa fa-2x fa-credit-card" aria-hidden="true"></i>
                  </span>
                  <i className="fa fa-2x fa-chevron-right" aria-hidden="true"></i>
                </div>
                <div className="heading"></div>
                <div className="desc"></div>
              </div>
              <div className="point">
                <div className="icon">
                  <span>
                    <i className="fa fa-2x fa-television" aria-hidden="true"></i>
                  </span>
                </div>
                <div className="heading">Website</div>
                <div className="desc"></div>
              </div>
            </div>
            <div id="sahaj-quote-small">Ideas, Action Impact!</div>
          </div>
          {(() => {
            if (this.state.forgotPassword === false) {
              return (
                <div className="form">
                  <div id="login">
                    <h1>Welcome Back!</h1>
                    <form id="login-form" onSubmit={this.loginUser}>
                      <div className="field-wrap">
                        <label> Email Address<span className="req">*</span> </label>
                        <input id="email" type="email" required autoComplete="off" onChange={this.change}/>
                      </div>
                      <div className="field-wrap">
                        <label> Password<span className="req">*</span> </label>
                        <input id="password" type="password" required autoComplete="off" onChange={this.change}/>
                      </div>
                      <div className="field-wrap">
                        <span className="red-color wrong-details">Invalid details. Try again!</span>
                      </div>
                      <button className="button button-block">
                        <i id="login-spinner" className="fa fa-spinner fa-spin hidden"></i>
                        <span id="login-span">Log In</span>
                      </button>
                      {/*<a className="forgot">
                        <span id="forgot-span" onClick={this.forgotPassword.bind(this)}>Forgot Password?</span>
                      </a>*/}
                    </form>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="form forgot">
                  <div className="tab-content">
                    <h2>Forgot Password</h2>
                    <div id="forgot-password">
                      <div className="field-wrap">
                        <label> Email Address<span className="req">*</span> </label>
                        <input id="email" type="email" required autoComplete="off" onChange={this.changeForgotPasswordEmail.bind(this)}/>
                        <span hidden={this.state.forgotPasswordEmailValid}><span className="required-span"> Incorrect Email entered! </span></span>
                      </div>
                      <button className="button button-block" onClick={this.forgotPasswordSubmit.bind(this)}>
                        <span id="login-span">Submit</span>
                        <i className="fa fa-check" hidden={!this.state.submittedForgotPassword}></i>
                      </button>
                      <h4>Enter your registered email and a new password will be sent to the registered email.</h4>
                      <a className="forgot">
                        <span id="forgot-span" onClick={this.forgotPassword.bind(this)}>
                          <i className="fa fa-chevron-left"></i> Back
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              );
            }
          })()}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.js